import React from 'react';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import MiniProfileIdentity from '../_partials/MiniProfileIdentity';
import { PapiUser } from '@wix/da-types-papi';
import reduxConnectContainer from './RecentVisitors.container';

import s from './RecentVisitors.scss';

export interface Props {
  isOwner: boolean;
  moduleId: number;
  visitors: PapiUser[];
}

export class RecentVisitors extends React.Component<Props> {
  render() {
    const { visitors } = this.props;
    const isEmpty = !visitors || visitors.length === 0;
    return isEmpty ? null : this.renderGrid();
  }

  renderGrid() {
    const { visitors } = this.props;
    return (
      <ElementQueries widthBreakpoints={[640, 800]} className={s['grid']}>
        {visitors.map(this.renderGridElement)}
      </ElementQueries>
    );
  }

  renderGridElement = (visitor: PapiUser) => {
    const { username } = visitor;
    return (
      <MiniProfileIdentity
        key={username}
        className={s['visitor']}
        user={visitor}
      />
    );
  };
}

export default reduxConnectContainer(RecentVisitors) as React.ComponentType<
  Props
>;
